// extracted by mini-css-extract-plugin
export default {"main":"main-page_main__4l-wV","main__content":"main-page_main__content__WnW3e","title":"main-page_title__RTpCv"};